import { brandThemePresets, normalizeBrandThemeSetting, type BrandThemeSetting } from '../../../design-system';
import type { OrganizationSettings } from './types';
export function normalizeOrganizationSettings(settings: OrganizationSettings): OrganizationSettings {
  return {
    ...settings,
    brandTheme: normalizeBrandThemeSetting(settings.brandTheme),
  };
}
export function brandThemeKey(theme: BrandThemeSetting) {
  if (theme.presetId === 'custom-v1')
    return JSON.stringify({
      presetId: theme.presetId,
      primaryColor: theme.primaryColor?.trim().toUpperCase(),
      navigationColor: theme.navigationColor?.trim().toUpperCase(),
      accentColor: theme.accentColor?.trim().toUpperCase(),
      surfaceTone: theme.surfaceTone === 'cool' ? undefined : theme.surfaceTone,
    });
  return JSON.stringify({
    ...normalizeBrandThemeSetting(theme),
  });
}
export function brandThemeLabel(theme: BrandThemeSetting) {
  return brandThemePresets.find((preset) => preset.id === theme.presetId)?.label ?? '기본 인디고';
}
export function validHexColor(value?: string) {
  return /^#[0-9A-F]{6}$/i.test(value ?? '');
}
export function formattedUpdatedAt(updatedAt?: string) {
  return updatedAt ? new Date(updatedAt).toLocaleString('ko-KR') : '아직 별도로 저장하지 않음';
}
